// import { NormalInput } from "./Input/NormalInput";
// import EmailInput from "./Input/EmailInput";
import SingleChoiceOne from "./Input/SingleChoiceOne";
// import { NormalInput2 } from "./Input/NormalInput2";
import { MultiChoiceProp } from "./Input/MultiChoiceProp";
// import { DateInput } from "./Input/DateInput";
import Rating from "../../../../components/Rating/Rating";
import Label from "../../../../components/Modules/Label";
import { QuestionSectionsProps } from "../types/SurveyTypes";
import { LabelModule } from "../../onboarding/Modules/LabelModule";
import { TextInputModule } from "../../onboarding/Modules/TextInputModule";
import { EmailInputModule } from "../../onboarding/Modules/EmailInputModule";
// import { SingleChoiceModal1 } from "../../onboarding/Modules/SingleChoiceModal1";
// import { SingleChoiceModal3 } from "../../onboarding/Modules/SingleChoiceModal3";
import { TextAreaModule } from "../../onboarding/Modules/TextAreaModule";
// import { MultiChoiceModal1 } from "../../onboarding/Modules/MultiChoiceModal1";
// import { MultiChoiceModal2 } from "../../onboarding/Modules/MultiChoiceModal2";
import { DateInputModule } from "../../onboarding/Modules/DateInputModule";
import { NumberInputModule } from "../../onboarding/Modules/NumberInputModule";

const QuestionSections: React.FC<QuestionSectionsProps> = ({
  data,
  answer,
  handleUpdate,
  handleRatingChange,
  handleRadioChange,
  selectedOptions,
  handleCheckboxChange,
  ratingType,
  sections,
  // page,
  themeManager,
  singleChoiceModal = "modal3",
  multiChoiceModal = "modal1",
  validateInputRegex,
  // onboardingGetPropsFunctions,
}) => {


  const getCheckedValue = () => {
    if (singleChoiceModal === "modal3") {
      const checkedValue = answer[data.actionId] || "";
      return checkedValue;
    } else {
      const checkedValue = answer[data.actionId] || "";
      return checkedValue;
    }
  };
  
  switch (data.type) {
    case "USER_INPUT_TEXT":
      return (
        <div style={{ boxSizing: "border-box" }}>
          <div className="label-input-cont" key={data.actionId}>
            <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
              {`${data?.question || ""} ${!!data?.required ? "*" : ""}`}
            </LabelModule>
            <TextInputModule
              placeholder={data?.placeholder || data?.question || ""}
              value={answer[data.actionId || ""]}
              validateInputRegex={(validation) => { }}
              errorText={themeManager.getTextInputErrorText()}
              textErrorStyle={themeManager.getTextInputErrorStyles()}
              regexKey={data?.regexKey}
              regexMessage={data?.regexMessage}
              onChange={(e) => handleUpdate(e, data.actionId || "", "")}
              style={themeManager.getTextInputStyles()}
              key={data.actionId}
            />
          </div>
          {/* <NormalInput
            question={data.question || "Name"}
            criteriaId={data.actionId || ""}
            type="text"
            required={data.required || false}
            placeholder={data.placeholder}
            answer={answer}
            handleUpdate={handleUpdate}
            themeManager={themeManager}
          /> */}
        </div>
      );
    case "USER_INPUT_EMAIL":
      return (
        <div style={{ boxSizing: "border-box" }}>
          <div className="label-input-cont" key={data?.actionId}>
            <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
              {`${data?.question || ""} ${
                !!data?.required || false ? "*" : ""
              }`}
            </LabelModule>
            <EmailInputModule
              placeholder={data?.placeholder || data?.question || ""}
              value={answer[data?.actionId || ""]}
              iconColor={themeManager.getEmailIconColor()}
              validateInputRegex={(validation) =>
                validateInputRegex(validation, data.actionId)
              }
              regexKey={data?.regexKey}
              regexMessage={data?.regexMessage}
              onChange={(e) => handleUpdate(e, data.actionId || "", "")}
              style={themeManager.getTextInputStyles()}
              emailtext={themeManager.getEmailInputErrorText()}
              emailErrorStyle={themeManager.getEMailInputErrorStyles()}
              // key={data?.actionId}
            />
          </div>
          {/* <EmailInput
            question={data.question || ""}
            actionId={data.actionId || ""}
            required={data.required || false}
            placeholder={data.placeholder}
            answer={answer}
            handleUpdate={handleUpdate}
            themeManager={themeManager}
          /> */}
        </div>
      );
    case "USER_INPUT_SINGLE_CHOICE":
      return (
        <div>
          {/* {singleChoiceModal === "modal1" || singleChoiceModal === "modal2" ? (
            <div className="label-input-cont" key={data.actionId}>
              <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                {`${data?.question || ""} ${!!data?.required ? "*" : ""}`}
              </LabelModule>
              <SingleChoiceModal1
                options={data.options || []}
                type={onboardingGetPropsFunctions?.getSingleChoose()}
                onChange={(e) => handleUpdate(e, data.actionId || "", "radio")}
                checked={getCheckedValue()}
                style={themeManager.getSingleChoiceStyles()}
                hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                key={data?.actionId}
              />
              {data?.manualInput != false &&
                answer[data.actionId || ""] == data?.manualInput && (
                  <TextInputModule
                    type={"text"}
                    onChange={(e) =>
                      handleUpdate(e, data.actionId || "" + "/manual", "")
                    }
                    value={answer[data.actionId || "" + "/manual"]}
                    placeholder="Please fill manually"
                    style={themeManager.getTextInputStyles()}
                    key={data?.actionId}
                  />
                )}
            </div>
          ) : (
            <div className="label-input-cont" key={data.actionId}>
              <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                {`${data?.question || ""} ${!!data?.required ? "*" : ""}`}
              </LabelModule>
              <SingleChoiceModal3
                options={data.options || []}
                type={onboardingGetPropsFunctions?.getSingleChoose()}
                onChange={(e) =>
                  handleUpdate({ target: e }, data.actionId || "", "")
                }
                checked={getCheckedValue()}
                style={themeManager.getSingleChoiceStyles()}
                hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                key={data?.actionId}
              />
              {data?.manualInput != false &&
                answer[data.actionId || ""] == data?.manualInput && (
                  <TextInputModule
                    type={"text"}
                    onChange={(e) =>
                      handleUpdate(e, data.actionId || "" + "/manual", "")
                    }
                    value={answer[data.actionId || "" + "/manual"]}
                    placeholder="Please fill manually"
                    style={themeManager.getTextInputStyles()}
                  />
                )}
            </div>
          )} */}
          <SingleChoiceOne
            options={data.options || []}
            question={data?.question || ""}
            required={data.required || false}
            actionId={data.actionId || ""}
            answer={answer}
            handleRadioChange={handleRadioChange}
            themeManager={themeManager}
            singleChoiceModal={singleChoiceModal}
          />
        </div>
      );
    case "USER_INPUT_TEXTAREA":
      return (
        <div>
          <div className="label-input-cont">
            <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
              {`${data?.question || ""} ${
                !!data?.required || false ? "*" : ""
              }`}
            </LabelModule>
            <TextAreaModule
              value={answer[data.actionId || ""]}
              onChange={(e) => handleUpdate(e, data.actionId || "", "")}
              style={themeManager.getTextAreaInputStyles()}
              textareatext={themeManager.getTextAreaInputErrorText()}
              textareaErrorStyle={themeManager.getTextAreaInputErrorStyles()}
              validateInputRegex={(validation) =>
                validateInputRegex(validation, data.actionId)
              }
              placeholder={data?.placeholder || data?.question || ""}
              key={data?.actionId}
            />
          </div>
          {/* <NormalInput2
            question={data.question || ""}
            criteriaId={data.actionId || ""}
            required={data.required || false}
            placeholder={data.placeholder}
            answer={answer}
            handleUpdate={handleUpdate}
            themeManager={themeManager}
          /> */}
        </div>
      );
    case "RATING":
      return (
        <div className="mb-4">
          <Label className="q-fd-lebels" style={themeManager.getLabelStyles()}>
            {`${data.question ? data.question : "Rating Scale"}${
              data.required === true ? "*" : ""
            }`}
          </Label>
          <div
            style={{
              display: "flex",
              marginTop: "6px",
            }}
          >
            <Rating
              count={5}
              getCurrentRating={(item) =>
                handleRatingChange(data.actionId, item)
              }
              defaultRating={Number(answer[data?.actionId])}
              RatingStyle={themeManager.getRatingStyles()}
              type={data?.ratingType || data?.metadata?.ratingType || ratingType}
              leftText={data?.leftRatingText || data?.metadata?.leftRatingText}
              rightText={data?.rightRatingText || data?.metadata?.rightRatingText}
              centerRatingText={data?.centerRatingText || data?.metadata?.centerRatingText}
            />
          </div>
        </div>
      );
    case "USER_INPUT_MULTI_CHOICE":
      return (
        <div style={{ boxSizing: "border-box" }}>
          {/* {(!!onboardingGetPropsFunctions?.getMultiChoice() &&
            onboardingGetPropsFunctions?.getMultiChoice() == "modal2") ||
          multiChoiceModal == "modal2" ? (
            <div className="label-input-cont">
              <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                {`${data?.question || ""} ${
                  !!data?.required || false ? "*" : ""
                }`}
              </LabelModule>
              <MultiChoiceModal2
                options={data.options || []}
                checked={
                  !!selectedOptions[data.actionId || ""] && selectedOptions[data.actionId || ""]
                }
                onChange={(e) => handleUpdate(e, data.actionId || "", "check")}
                modalType={onboardingGetPropsFunctions?.getMultiChoice()}
                style={themeManager.getMultiChoiceStyles()}
                selectedStyle={themeManager.getMultiChoiceSelectedStyles()}
                key={data?.actionId}
              />
            </div>
          ) : (
            <div className="label-input-cont">
              <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                {`${data?.question || ""} ${
                  !!data?.required || false ? "*" : ""
                }`}
              </LabelModule>
              <div style={{ width: "90%" }}>
                <MultiChoiceModal1
                  options={data.options || []}
                  checked={
                    // !!selectedOptions[data.actionId || ""] && selectedOptions[data.actionId || ""]
                    selectedOptions && Array.isArray(selectedOptions[data.actionId])
                    ? selectedOptions[data.actionId]
                    : undefined
                  }
                  onChange={(e) =>
                    handleUpdate(e, data.actionId || "", "check")
                  }
                  modalType={onboardingGetPropsFunctions?.getMultiChoice()}
                  style={themeManager.getMultiChoiceStyles()}
                  selectedStyle={themeManager.getMultiChoiceSelectedStyles()}
                  key={data?.actionId}
                />
              </div>
            </div>
          )} */}
          <MultiChoiceProp
            options={data.options || []}
            question={data?.question || ""}
            required={data.required || false}
            actionId={data.actionId || ""}
            selectedOptions={selectedOptions}
            handleCheckboxChange={handleCheckboxChange}
            themeManager={themeManager}
            multiChoiceModal={multiChoiceModal}
          />
        </div>
      );
    case "USER_INPUT_DATE":
      return (
        <div style={{ boxSizing: "border-box" }}>
          <div className="label-input-cont" key={data.actionId}>
            <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
              {`${data?.question || ""} ${!!data?.required ? "*" : ""}`}
            </LabelModule>
            <DateInputModule
              placeholder={data?.placeholder || data?.question || ""}
              value={answer[data.actionId || ""]}
              onChange={(e) => handleUpdate(e, data.actionId || "", "")}
              iconColor={themeManager.getEmailIconColor()}
              style={themeManager.getTextInputStyles()}
              key={data.actionId}
              preventFutureSelection={false}
              preventPastSelection={false}
              minDate=""
              maxDate=""
            />
          </div>
          {/* <DateInput
            question={data.question || ""}
            required={data.required || false}
            actionId={data.actionId || ""}
            placeholder={data.placeholder || sections?.[0]?.placeholder || ""}
            answer={answer}
            handleUpdate={handleUpdate}
            themeManager={themeManager}
          /> */}
        </div>
      );
    case "USER_INPUT_PHONE":
    case "USER_INPUT_NUMBER":
      return (
        <div style={{ boxSizing: "border-box" }}>
          <div className="label-input-cont">
            <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
              {`${data?.question || ""} ${
                !!data?.required || false ? "*" : ""
              }`}
            </LabelModule>
            <NumberInputModule
              placeholder={data?.placeholder || data?.question || ""}
              value={answer[data.actionId || ""]}
              iconColor={themeManager.getEmailIconColor()}
              validateInputRegex={(validation) => { }}
              regexKey={data?.regexKey}
              regexMessage={data?.regexMessage}
              onChange={(e) => handleUpdate(e, data.actionId || "", "")}
              style={themeManager.getTextInputStyles()}
              numbertext={themeManager.getNumberInputErrorText()}
              numberErrorStyle={themeManager.getNumberInputErrorStyles()}
              key={data?.actionId}
            />
          </div>
          {/* <NormalInput
            question={data.question || "Name"}
            criteriaId={data.actionId || ""}
            type="number"
            required={data.required || false}
            placeholder={data.placeholder}
            answer={answer}
            handleUpdate={handleUpdate}
            themeManager={themeManager}
          /> */}
        </div>
      );
    default:
      return null;
  }
};

export default QuestionSections;
